import React from 'react';
import {push} from 'connected-react-router';
import {uiActions} from './chrome';

export const handleError = dispatch => err => {
	console.error(err);

	if (err && err.name === '401') {
		// Destroy session state, show expiry message and prompt to login
		dispatch({
			type: 'SESSION_LOGIN_EXPIRED' // NOTE; Nasty hack because we got some weird import race condition here
		});
		localStorage.removeItem('loginShown');
		dispatch(uiActions.uiModal('login'));
	} else if (err && err.name === '403') {
		dispatch(push('/forbidden'));
	} else if (err && err.name === '404') {
		dispatch(push('/404')); // not found
	} else {
		dispatch(
			uiActions.uiMessage({
				content: () => (
					<div>
						<strong>An unexpected error occurred.</strong>
						<div>
							If you need assistance, please contact our support at{' '}
							<a href="https://b2me.zendesk.com">https://b2me.zendesk.com</a>
						</div>
					</div>
				),
				type: 'error'
			})
		);
	}
};

export default handleError;



// WEBPACK FOOTER //
// ./src/handleError.js